import { render, staticRenderFns } from "./FundraiserBoxRaises.vue?vue&type=template&id=183777b9&scoped=true&"
import script from "./FundraiserBoxRaises.vue?vue&type=script&lang=js&"
export * from "./FundraiserBoxRaises.vue?vue&type=script&lang=js&"
import style0 from "./FundraiserBoxRaises.vue?vue&type=style&index=0&id=183777b9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183777b9",
  null
  
)

export default component.exports